import axios from 'axios';
import { apiRoot } from '@/config/config';
export async function designValue(params: any, token: string) {
  return await axios({
    url: `${apiRoot}/design_values`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//查询单条记录 设计值
export async function getDesignValue(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/design_values/${id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//更新job
export async function updateJob(job_id: any, data: any, token: string) {
  return await axios({
    url: `${apiRoot}/jobs/${job_id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//创建设计值
export async function createDesignValue(data: any, token: string) {
  return await axios({
    url: `${apiRoot}/design_values`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除设计值
export async function deleteDesignValue(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/design_values/${id}`,
    method: 'delete',
    // params:{id},
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//实际值存储列表
export async function actList(token: string) {
  return await axios({
    url: `${apiRoot}/pi_data/computes/ids`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//查询单条实际值（按 id 获取存储的实际值详情）
export async function getActValue(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/pi_data/computes/${id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//创建工况数据（实际值项）：{ name, times: ["YYYY-MM-DD HH:mm:ss", ...] }
export async function createActValue(data: any, token: string) {
  return await axios({
    url: `${apiRoot}/pi_data/computes`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除实际值（按 id 删除存储的工况数据）
export async function deleteActValue(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/pi_data/computes/${id}`,
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//更新实际值（按 id 更新存储的工况数据）：可只改 name / result，未传字段保持原值
export async function updateActValue(id: any, data: any, token: string) {
  return await axios({
    url: `${apiRoot}/pi_data/computes/${id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}